import script from "./UserAvatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./UserAvatar.vue?vue&type=script&setup=true&lang=ts"

export default script